/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetOrganizationPoints200Response
 */
export interface GetOrganizationPoints200Response {
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationPoints200Response
     */
    currencyPoints: number;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationPoints200Response
     */
    tabPoints: number;
}

/**
 * Check if a given object implements the GetOrganizationPoints200Response interface.
 */
export function instanceOfGetOrganizationPoints200Response(value: object): value is GetOrganizationPoints200Response {
    if (!('currencyPoints' in value) || value['currencyPoints'] === undefined) return false;
    if (!('tabPoints' in value) || value['tabPoints'] === undefined) return false;
    return true;
}

export function GetOrganizationPoints200ResponseFromJSON(json: any): GetOrganizationPoints200Response {
    return GetOrganizationPoints200ResponseFromJSONTyped(json, false);
}

export function GetOrganizationPoints200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrganizationPoints200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'currencyPoints': json['currencyPoints'],
        'tabPoints': json['tabPoints'],
    };
}

export function GetOrganizationPoints200ResponseToJSON(json: any): GetOrganizationPoints200Response {
    return GetOrganizationPoints200ResponseToJSONTyped(json, false);
}

export function GetOrganizationPoints200ResponseToJSONTyped(value?: GetOrganizationPoints200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currencyPoints': value['currencyPoints'],
        'tabPoints': value['tabPoints'],
    };
}

